
<div class="container-fluid px-md-2 px-0">
  <div class="row">
    <!--Composant historique-->
    <div *ngIf="mobile" class="col-lg-5 col-xl-6 my-2 my-sm-4">
      <fieldset class="q-fieldset" style="min-height: 970px; ">
        <legend><i class="fas fa-history"></i> Historique</legend>
        <ng-container *ngIf="service.Stage && service.Stage.Ident != '0'">
          <q-history [Type]="'STAGE'" [Ident]="service.Stage.Ident"></q-history>
        </ng-container>
      </fieldset>
    </div>
    <!-- Fin Composant historique -->
    <div class="col-lg-7 col-xl-6 my-2 my-sm-4">
      <div class="row vision360">
        <q-effectifs class="col-lg-6 my-2 my-sm-4" [Option]="OptionClient" (service)="setService('client', $event)"></q-effectifs>
        <q-effectifs class="col-lg-6 my-2 my-sm-4" [Option]="OptionContact" (service)="setService('stagiaire', $event)">
          <ng-template let-Effectif #mytemplate>
            <i *ngIf="Effectif.IdClient.length == 0" title="Cet apprenant n’est plus lié à un client du stage" class="q-pointer q-c-warning fa-solid fa-triangle-exclamation" style="width: 10px;text-align: center;"></i>

            <div *ngIf="Effectif.ExtranetMailSend else mailSend">
              <div><i class="fa-regular fa-paper-plane q-c-success" title="Identifiant extranet envoyé par mail"></i></div>
            </div>
            <ng-template #mailSend><div><i class="fa-regular fa-paper-plane q-c-danger" title="Identifiant extranet non envoyé par mail"></i></div></ng-template>
          </ng-template>
        </q-effectifs>
        <!-- Les Documents -->
        <div class="col-lg-6 mb-lg-3 my-sm-4 my-4">
          <fieldset class="h-100 q-fieldset">
            <legend><i class="fas fa-folder"></i> Documents</legend>
            <div class="h-100 w-100 documentHeight">
              <queoval-stage-doc360></queoval-stage-doc360>
            </div>
          </fieldset>
        </div>
        <!-- Fin des documents -->
        <q-effectifs class="col-lg-6 my-2 my-sm-4" [Option]="OptionFormateur"></q-effectifs>

        <!-- Les Graphiques -->
        <ng-container *ngFor="let chart of ChartListToUse">
          <div class="col-md-6 col-lg-12 col-xl-6 my-3" >
            <fieldset class="q-fieldset height-160px" >
              <legend>
                <i *ngIf="chart.value == 'Facturation HT'" class="fas fa-euro-sign"></i>
                <i *ngIf="chart.value == 'Planning heures'" class="fas fa-calendar-check"></i>
                <i *ngIf="chart.value == 'Dépenses HT'" class="fas fa-balance-scale"></i>
                <i *ngIf="chart.value == 'Présences'" class="fas fa-calendar-check"></i>
                {{chart.value}}
              </legend>
              <div class="h-100 w-100 mx-2">
                <basic-echart [Mode]="chart.id" [Id]="service.Stage.Ident"></basic-echart>
              </div>
            </fieldset>
          </div>
        </ng-container>
        <!-- Fin des graphiques -->

      </div>

    </div>
    <div *ngIf="!mobile" class=" col-lg-5 col-xl-6 my-5">
      <fieldset class="q-fieldset" style="min-height: 970px;">
        <legend><i class="fas fa-history"></i> Historiques</legend>
        <!--Composant historique-->
        <ng-container *ngIf="service.Stage && service.Stage.Ident != '0'">
          <q-history [Type]="'STAGE'" [Ident]="service.Stage.Ident"></q-history>
        </ng-container>
      </fieldset>
    </div>
  </div>
</div>
